"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("../../../../swcp-base/fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UserListLicensePill = props => {
  const {
    schema
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", null, props.value && props.value.map((value, index) => {
    const label = schema.getDisplayName ? schema.getDisplayName(value[schema.entities.foreign]) : value[schema.entities.foreign] !== undefined ? value[schema.entities.foreign][schema.entities.displayName] : null;
    if (!label) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "badge badge-pill badge-primary",
      key: index
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "material-icons text-white d-inline-block",
      style: {
        marginBottom: "0.1rem",
        marginRight: "0.3rem"
      }
    }, value.ActivatedAt ? /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "VDC_IconFont_RadioFullChecked",
      size: 15
    }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "VDC_IconFont_RadioOff",
      size: 15
    }))), /*#__PURE__*/_react.default.createElement("span", null, label));
  }));
};
var _default = exports.default = UserListLicensePill;
module.exports = exports.default;